import { isUnchanged, resolveReference } from '@/utils/object'
import { retrieveItem } from './retrieveItem'
import type { Id, Item } from './types'
import { updateItem } from './updateItem'

const isSameList = <T>(a: T[], b: T[]) =>
  a.length === b.length && a.every((item, index) => item === b[index])

export const replaceChangedItem = <T extends Item<Id>>(
  items: T[],
  target: T,
): T[] => {
  const current = retrieveItem(items, target.id)
  return isUnchanged(current, target) ? items : updateItem(items, target)
}

export const replaceChangedItems = <T extends Item<Id>>(
  items: T[],
  nextItems: T[],
): T[] => {
  const merged = nextItems.map((next) =>
    resolveReference(retrieveItem(items, next.id), next),
  )
  return isSameList(items, merged) ? items : merged
}
